module.exports = __webpack_public_path__ + "img/scan-processing.634dd64a.svg";